import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GoogleAnalyticsService } from '@core/services/google-analytics.service';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  private gaService = inject(GoogleAnalyticsService);

  ngOnInit(): void {
    this.gaService.init();
    this.gaService.setUserPropertiesFromSession();
  }

}